export const IMAGES = [
  { src: "https://i.ibb.co/McJJTCN/image.jpg", thumbnail: "https://i.ibb.co/McJJTCN/image.jpg" },
{ src: "https://i.ibb.co/mTkbMBQ/1.jpg", thumbnail: "https://i.ibb.co/mTkbMBQ/1.jpg" },
];
